import { Component, Input, OnInit } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DialogService } from 'primeng/dynamicdialog';

import { DataService, HTTPService, HelperService, CalculationService, FormatService } from 'app/services';
import { FlatRateItem, FlatRateSubItem } from 'app/services/sharedInterfaces';
import { messages } from 'app/constants';
import { currency } from 'app/constants/currency.constants';
import { Subscription } from 'rxjs';
import { debounce } from 'lodash';
import { UpdateCannedServiceDialogComponent } from 'app/modules/app-components/update-canned-service-dialog/update-canned-service-dialog.component';

@Component({
  selector: 'app-flat-rate-add',
  templateUrl: './flat-rate-add.component.html',
  styleUrls: ['./flat-rate-add.component.scss'],
})
export class FlatRateAddComponent implements OnInit {
  @Input() isQboConnected: boolean = false;
  @Input() defaultTaxable: boolean = false;
  @Input() isCommissionPlanEnabled: boolean = false;
  @Input() isOpenFromPO: boolean = false;
  @Input() qboItemRefs: any[] = [];
  @Input() isLoading: boolean = false; // don't set this key inside this component
  @Input() data: any = {};
  @Input() item: any = {};
  @Input() bundleId: string = '';
  @Input() isLocal: boolean = true;
  @Input() orderServiceItemIndex: number = -1;
  @Input() orderServiceId: string = '';
  @Input() serviceItem: any = {};
  @Input() openFrom: string = 'catalog';
  @Input() discountOn: string = 'service';
  @Input() orderId: string = '';
  @Input() order: any = {};
  @Input() isFinalizedRo: boolean = false;
  @Input() isQuickServiceEnabled: boolean = false;
  @Input() partsLookupDropDownList: any[] = [];
  @Input('titleForCreate')
  set titleForCreate(title: any) {
    if (title) {
    }
  }

  flatRate: FlatRateItem = {
    _id: '',
    title: '',
    titleFR: '',
    itemSourceId: '',
    type: 'bundle',
    description: '',
    descriptionFR: '',
    externalId: '',
    tooltip: '',
    status: true,
    isTaxable: true,
    displayHoursOnOrder: false,
    displayDescOnOrder: false,
    flatRate: 0,
    subItems: [],
    itemTotal: {
      part: 0,
      labor: 0,
      tire: 0,
      other: 0,
      totalItemCount: 0,
      totalCost: 0,
      totalAmount: 0,
    },
  };
  flatRateSubItem: FlatRateSubItem = {
    itemId: '',
    type: '',
    title: '',
    titleFR: '',
    code: '',
    description: '',
    descriptionFR: '',
    externalId: '',
    tooltip: '',
    qboId: '',
    isTaxable: false,
    stocked: false,
    cost: 0,
    price: 0,
    count: 0,
    totalCost: 0,
    netSubtotal: 0,
    flatRateAmount: 0,
    supplier: null,
    commissionable: false,
    costEstimatedHours: 0,
    displayHoursOnOrder: false,
    displayDescOnOrder: false,
    isPassThroughTax: false,
    qboItemRefId: '',
    locationQboItemRefId: {},
    category: {},
    salesCode: {},
    tags: [],
    isWarrantyEligible: false,
    warranty: {},
    partSpecification: {}
  };
  usd: string = currency.USD;
  focus: any = { title: true };
  flatRateErrors: any = {};
  errors: any[] = [];
  isProcessing: boolean = false;
  isCreateAnother: boolean = false;
  updateGenericItem: boolean = false;
  isCheckingUniqueness: boolean = false;
  isSaving: boolean = true;
  isTitleUnique: boolean = true;
  defaultSuppliers: any[] = [];
  isLoadingSuppliers: boolean = false;
  activityLogs: any[] = [];
  selectedTab: number = 0;
  isLockedRO = false;
  localizationSubscription: Subscription;
  companyLocalization: boolean = false;
  currentLang: string = 'en';
  initialBundleState: any;
  updatedInputStates: any = {};

  constructor(
    public dynamicDialogRef: DynamicDialogRef,
    public dConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    private httpService: HTTPService,
    private calculationService: CalculationService,
    private helperService: HelperService,
    public dataService: DataService,
    private formatService: FormatService,
    private currencyPipe: CurrencyPipe
  ) { }

  ngOnInit() {

    this.getLocalizationFlags();
    this.getSupplierList();

    if (this.bundleId) {
      this.getLogs();
    }
    if (this.openFrom === 'RO') {
      this.isLockedRO = this.dataService.isLockedRO;
    }
  }

  getLocalizationFlags() {
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    this.localizationSubscription = this.dataService.getCompanyLocalization().subscribe((value) => {
      if (value) {
        this.companyLocalization = value
        if (!isMultiLocationEnabled) {
          this.httpService.getCompanyPreferredLanguage().then((res: any) => {
            const lang = res.preferredLanguage
            if (lang) {
              this.currentLang = lang.toLowerCase();
            }
          });
        } else {
          this.httpService.getCompanyDetails(this.helperService.getCompany().companyId).then((company: any) => {
            const lang = company.shop.preferredLanguage;
            if (lang) this.currentLang = lang.toLowerCase();
          })
        }
      }
    })
  }

  ngOnDestroy() {
    if (this.localizationSubscription) this.localizationSubscription.unsubscribe();
  }

  ngOnChanges(change: any) {
    const { isLoading } = change;

    if (isLoading) {
      if (isLoading.previousValue && !isLoading.currentValue) {
        if (!this.bundleId) {
          this.isSaving = false;
          this.flatRate.isTaxable = this.defaultTaxable;
        }

        this.setItemDetails(this.item);
        this.setFlatRateData();
        this.initialBundleState =this.helperService.deepCopy(this.flatRate);
        this.isSaving = false;
      }
    }
  }

  getLogs() {
    const query = <any>{};
    query.entityId = this.bundleId;
    this.httpService.getActivityLog(query).then(
      (data: any) => {
        console.log(data);
        if (data) {
          this.activityLogs = this.formatService.formateCatlogActivityLogs(data);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  getSupplierList() {
    this.isLoadingSuppliers = true;
    this.httpService.getSuppliers(false, 'true').then(
      (data: any) => {
        if (data && data.records) {
          this.defaultSuppliers = data.records;
        }
        this.isLoadingSuppliers = false;
      },
      (err) => {
        this.helperService.showToaster('error', err);
        this.isLoadingSuppliers = false;
      }
    );
  }

  setItemDetails(data: any) {
    if (this.bundleId && data) {
      this.flatRate.title = data.title;
      this.flatRate.titleFR = data.titleFR;
      this.flatRate.type = 'bundle';
      this.flatRate.status = data.status;
      this.flatRate.isTaxable = data.isTaxable;
      this.flatRate.description = data.description;
      this.flatRate.descriptionFR = data.descriptionFR;
      this.flatRate.externalId = data.externalId;
      this.flatRate.subItems = [...(data.subItems || [])];
      this.flatRate.flatRate = data.flatRate;
      this.flatRate.displayDescOnOrder = data.displayDescOnOrder;
      this.flatRate.displayHoursOnOrder = data.displayHoursOnOrder;
      this.flatRate.itemTotal.totalAmount = data.itemTotal.totalAmount;
      this.flatRate.itemTotal.totalCost = data.itemTotal.totalCost;
    }

    this.handleSubItemAdd();
    this.isSaving = false;
  }

  setFlatRateData() {
    if (this.serviceItem && this.serviceItem.itemId) {
      this.flatRate = {
        ...this.flatRate,
        status: true,
        isTaxable: this.serviceItem.isTaxable,
      };

      if (this.serviceItem.hasOwnProperty('title')) {
        this.flatRate.title = this.serviceItem.title;
      }
      if (this.companyLocalization) {
        if (this.serviceItem.hasOwnProperty('titleFR')) {
          this.flatRate.titleFR = this.serviceItem.titleFR;
        }
      }

      // if (this.serviceItem.hasOwnProperty('flatRate')) {
      //   this.flatRate.flatRate = this.serviceItem.flatRate;
      // }

      if (this.serviceItem.hasOwnProperty('subItems')) {
        this.flatRate.subItems = this.helperService.deepCopy(this.serviceItem.subItems);
        this.handleSubItemAdd();
      }

      if (this.serviceItem.hasOwnProperty('netSubTotal')) {
        this.flatRate.flatRate = this.serviceItem.netSubTotal;
      }

      if (this.serviceItem.hasOwnProperty('description')) {
        this.flatRate.description = this.serviceItem.description;
      }
      if (this.companyLocalization) {
        if (this.serviceItem.hasOwnProperty('descriptionFR')) {
          this.flatRate.descriptionFR = this.serviceItem.descriptionFR;
        }
      }

      if (this.serviceItem.hasOwnProperty('externalId')) {
        this.flatRate.externalId = this.serviceItem.externalId;
      }

      if (this.serviceItem.hasOwnProperty('itemSourceId')) {
        this.flatRate.itemSourceId = this.serviceItem.itemSourceId;
      }

      if (this.serviceItem.hasOwnProperty('displayHoursOnOrder')) {
        this.flatRate.displayHoursOnOrder = this.serviceItem.displayHoursOnOrder;
      }

      if (this.serviceItem.hasOwnProperty('displayDescOnOrder')) {
        this.flatRate.displayDescOnOrder = this.serviceItem.displayDescOnOrder;
      }
    }
  }

  handleSubItemAdd() {
    this.flatRate.subItems.push({
      ...this.flatRateSubItem,
    });
    this.errors.push({});
    this.handleCalculateFlatRateTotal();
  }

  handleSubItemDelete(index: number) {
    this.flatRate.subItems.splice(index, 1);
    this.errors.splice(index, 1);
    this.handleCalculateFlatRateTotal();
  }

  handleChange(name: string, value: string | number) {
    this.flatRate[name] = value;
    if (this.currentLang !== 'fr') {
      if (name === 'title') {
        this.handleUniqueTitleCheck();
      }
    }
  }

  handleFocus(name: string) {
    this.focus[name] = true;
    this.flatRateErrors[name] = '';
  }

  handleBlur(name: string) {
    this.focus[name] = false;
    this.flatRateErrors[name] = '';

    if (name === 'flatRate') {
      this.handleCalculateFlatRateTotal();
    }
    if (this.currentLang !== 'fr') {
      if (name === 'title') {
        this.handleUniqueTitleCheck();
      }
    }
  }

  handleClose(isSuccess: boolean = false) {
    this.dynamicDialogRef.close({ isSuccess });
  }

  handleCalculateFlatRateTotal() {
    this.flatRate.itemTotal = {
      part: 0,
      labor: 0,
      tire: 0,
      other: 0,
      totalItemCount: 0,
      totalCost: 0,
      totalAmount: 0,
    };
    let totalFlatRateAmount = 0;

    if (this.flatRate.subItems.length) {
      this.flatRate.subItems.forEach((subItem: FlatRateSubItem) => {
        subItem.totalCost = subItem.type === 'labor' ? this.calculationService.roundOff(subItem.cost * subItem.costEstimatedHours) : this.calculationService.roundOff(subItem.cost * subItem.count);
        subItem.netSubtotal = this.calculationService.roundOff(subItem.price * subItem.count);

        if (subItem.itemId || (subItem.type === 'other' && subItem.title)) {
          this.flatRate.itemTotal[subItem.type] += subItem.netSubtotal;
          this.flatRate.itemTotal.totalCost += subItem.totalCost;
          this.flatRate.itemTotal.totalAmount += subItem.netSubtotal;
          this.flatRate.itemTotal.totalItemCount += 1;
        }
      });
       this.flatRate.subItems.forEach((subItem: FlatRateSubItem) => {
        if ((subItem.itemId || (subItem.type === 'other' && subItem.title)) && subItem.netSubtotal > 0) {
           subItem.flatRateAmount = this.calculationService.roundOff(subItem.netSubtotal * (this.flatRate.flatRate / this.flatRate.itemTotal.totalAmount));
          totalFlatRateAmount += subItem.flatRateAmount;
      //     // subItem.tooltip = `
      //     //   <div class="flex-column pt-1 pb-1 width-100p">
      //     //     <p class="flex-between-center m-0">
      //     //       <span class="pl-2">Item&nbsp;amount</span>
      //     //       <span>${this.currencyPipe.transform(subItem.netSubtotal, this.usd)}</span>
      //     //     </p>
      //     //     <p class="flex-between-center m-0">
      //     //       <span class="pl-2">%&nbsp;Allocated&nbsp;deficit</span>
      //     //       <span>%${((Math.abs(subItem.netSubtotal - subItem.flatRateAmount) * 100) / subItem.netSubtotal).toFixed(2)}</span>
      //     //     </p>
      //     //     <p class="flex-between-center m-0">
      //     //       <span class="pl-2">Item&nbsp;net&nbsp;amount </span>
      //     //       <span>${this.currencyPipe.transform(subItem.flatRateAmount, this.usd)}</span>
      //     //     </p>
      //     //   </div>
      //     // `;
        }
      });

         if (totalFlatRateAmount > 0) {
          this.adjustFlatRateNetAmount(totalFlatRateAmount);
        }
          this.createSubITemTooltip();
      // let totalFlatRateAmount = 0;
      // this.flatRate.subItems.forEach(({ flatRateAmount }) => {
      //   totalFlatRateAmount += flatRateAmount;
      // });
    }
    this.flatRate.tooltip = `
      <div class="flex-column pt-1 pb-1 width-100p">
        <p class="flex-between-center m-0">
          <span class="pl-2">Flat&nbsp;rate</span>
          <span>${this.currencyPipe.transform(this.flatRate.flatRate, this.usd)}</span>
        </p>
        <p class="flex-between-center m-0">
          <span class="pl-2">Item&nbsp;total</span>
          <span>${this.currencyPipe.transform(this.flatRate.itemTotal.totalAmount, this.usd)}</span>
        </p>
        <p class="flex-between-center m-0">
          <span class="pl-2">Surplus/Deficit</span>
          <span>${this.currencyPipe.transform(Math.abs(this.flatRate.flatRate - this.flatRate.itemTotal.totalAmount), this.usd)}</span>
        </p>
      </div>`;
  }

  adjustFlatRateNetAmount(totalItemsFlatRateAmount: number) {
    if (this.flatRate?.subItems?.length) {
      const length = this.flatRate.subItems.filter((subItem: any) => subItem.type).length;
      if (length > 0) {
        if (totalItemsFlatRateAmount > this.flatRate.flatRate) {
          const difference = totalItemsFlatRateAmount - this.flatRate.flatRate;
          this.flatRate.subItems[length - 1].flatRateAmount = this.calculationService.roundOff(this.flatRate.subItems[length - 1].flatRateAmount - difference);
        } else if (totalItemsFlatRateAmount < this.flatRate.flatRate) {
          const difference = this.flatRate.flatRate - totalItemsFlatRateAmount;
          this.flatRate.subItems[length - 1].flatRateAmount = this.calculationService.roundOff(this.flatRate.subItems[length - 1].flatRateAmount + difference);
        }
      }
    }
  }

  createSubITemTooltip() {
    if (this.flatRate.subItems?.length) {
      const length = this.flatRate.subItems.filter((subItem: any) => subItem.type).length;
      if (length > 0) {
        this.flatRate.subItems.forEach((subItem: FlatRateSubItem) => {
          if (subItem.itemId || (subItem.type === 'other' && subItem.title)) {
            subItem.tooltip = `
              <div class="flex-column pt-1 pb-1 width-100p">
                <p class="flex-between-center m-0">
                  <span class="pl-2">Item&nbsp;amount</span>
                  <span>${this.currencyPipe.transform(subItem.netSubtotal, this.usd)}</span>
                </p>

                <p class="flex-between-center m-0">
                  <span class="pl-2">%&nbsp;Allocated&nbsp;deficit</span>
                  <span>%${((Math.abs(subItem.netSubtotal - subItem.flatRateAmount) * 100) / subItem.netSubtotal).toFixed(2)}</span>
                </p>

                <p class="flex-between-center m-0">
                  <span class="pl-2">Item&nbsp;net&nbsp;amount </span>
                  <span>${this.currencyPipe.transform(subItem.flatRateAmount, this.usd)}</span>
                </p>
              </div>
            `;
          }
        });
      }
    }
  }

  handleReset() {
    this.flatRate = {
      _id: '',
      title: '',
      titleFR: '',
      type: 'bundle',
      itemSourceId: '',
      description: '',
      descriptionFR: '',
      externalId: '',
      tooltip: '',
      status: true,
      isTaxable: true,
      displayHoursOnOrder: false,
      displayDescOnOrder: false,
      flatRate: 0,
      subItems: [],
      itemTotal: {
        part: 0,
        labor: 0,
        tire: 0,
        other: 0,
        totalItemCount: 0,
        totalCost: 0,
        totalAmount: 0,
      },
    };
    this.handleSubItemAdd();
    this.isSaving = false;
  }

  handleUniqueTitleCheck = debounce(async () => {
    this.isCheckingUniqueness = true;

    if (!this.flatRate.title) return;

    try {
      const isUnique = await this.httpService.isItemTitleUnique({ title: this.flatRate.title.trim(), type: 'bundle' }, this.bundleId);

      if (isUnique) {
        this.flatRateErrors.title = '';
        this.isTitleUnique = true;
      } else {
        this.flatRateErrors.title = 'Name should be unique';
        this.isTitleUnique = false;
        this.helperService.showToaster('error', 'Name should be unique');
      }
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.isCheckingUniqueness = false;
    }
  }, 500);

  async handleCreateBundle(bundle: any) {
    if (this.isProcessing) return;

    this.isProcessing = true;

    try {
      delete bundle._id;
      const data = await this.httpService.createItem(bundle);

      this.helperService.showToaster('success', messages.bundleCreated);
      this.dataService.sendData(this.dataService.typePassData('bundle-list', {}));

      if (this.isCreateAnother) {
        this.handleReset();
      } else {
        this.dynamicDialogRef.close();
      }

      if (this.orderServiceId) {
        this.dataService.sendData(
          this.dataService.typePassData('ro-service-item', {
            ...data,
            actionType: 'create',
            serviceId: this.orderServiceId,
            index: this.orderServiceItemIndex,
          })
        );
      } else if (this.openFrom === 'catalog') {
        this.dataService.sendData(this.dataService.typePassData('canned-service-item', { ...data, actionType: 'create' }));
      }
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.isProcessing = false;
    }
  }

  async openUpdateCannedServicesDialog(data) {
    try {
      const cannedServices = await this.httpService.getCannedServicesByItem(data._id);
      if (cannedServices.length === 0) return;
      data.cost = this.formatService.setDynamicCostAndPrice(data, 'cost');
      data.price = this.formatService.setDynamicCostAndPrice(data, 'price');
      // open update canned service dialog
      this.dialogService.open(UpdateCannedServiceDialogComponent, {
        width: '50%',
        styleClass: 'add-dialog add-part update-canned overflow-initial',
        showHeader: false,
        data: {
          part: data,
          cannedServices,
          updatedFields: Object.keys(this.updatedInputStates).filter((key) => {
            try {
              return this.updatedInputStates[key];
            } catch (e) {
              return false;
            }
          }),
        },
      });
    } catch (error) {
      this.helperService.showToaster('error', error);
    }
  }
  async handleUpdateBundle(bundle: any) {
    if (this.isProcessing) return;

    this.isProcessing = true;

    try {
      if (!this.updateGenericItem && this.openFrom === 'RO') {
        this.dataService.sendData(
          this.dataService.typePassData('ro-service-item', {
            ...bundle,
            actionType: 'update',
            serviceId: this.orderServiceId,
            index: this.orderServiceItemIndex,
          })
        );
        this.dynamicDialogRef.close({});
        return;
      }

      const data: any = await this.httpService.updateItem(bundle);

      this.helperService.showToaster('success', messages.bundleUpdate);
      this.dataService.sendData(this.dataService.typePassData('bundle-list', {}));
        this.updatedInputStates = {};
        let isUpdated = false;
    
        if (this.flatRate.flatRate !== this.initialBundleState.flatRate) {
          isUpdated = true;
          this.updatedInputStates.flatRate = this.flatRate.flatRate;
        }
        if (isUpdated) {
          
            this.openUpdateCannedServicesDialog(data);
        }
      this.dynamicDialogRef.close();

      if (this.orderServiceId) {
        if (this.serviceItem.itemSourceId) {
          data.itemSourceId = this.serviceItem.itemSourceId;
        }

        this.dataService.sendData(
          this.dataService.typePassData('ro-service-item', {
            ...data,
            actionType: 'update',
            serviceId: this.orderServiceId,
            index: this.orderServiceItemIndex,
          })
        );
      }
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.isProcessing = false;
    }
  }

  formatBundle() {
    const bundle = {
      _id: null,
      type: 'bundle',
      title: this.flatRate.title,
      titleFR: this.flatRate.titleFR,
      description: this.flatRate.description,
      descriptionFR: this.flatRate.descriptionFR,
      externalId: this.flatRate.externalId,
      status: this.flatRate.status,
      flatRate: this.flatRate.flatRate,
      count: 1,
      displayHoursOnOrder: this.flatRate.displayHoursOnOrder,
      displayDescOnOrder: this.flatRate.displayDescOnOrder,
      cost: this.flatRate.itemTotal.totalCost,
      price: this.flatRate.itemTotal.totalAmount,
      qboId: this.flatRate.itemTotal.totalCost,
      subItems: this.flatRate.subItems.filter(({ itemId, type, title, titleFR }) => itemId || (type === 'partLookUp' && (title || titleFR)) || (type === 'other' && (title || titleFR))),
      itemTotal: this.flatRate.itemTotal,
    };

    bundle.subItems.forEach((subItem: any) => {
      if (!subItem.itemId) {
        delete subItem.itemId;
      }

      subItem.displayDescOnOrder = this.flatRate.displayDescOnOrder;
      subItem.displayHoursOnOrder = this.flatRate.displayHoursOnOrder;
    });

    if (this.bundleId) {
      bundle._id = this.bundleId;
    }

    return bundle;
  }

  isValid() {
    let isValid = true;

    if (this.companyLocalization && this.currentLang === 'fr') {
      if (!this.flatRate?.titleFR?.trim()) {
        this.flatRateErrors.titleFR = 'French Title is required';
        isValid = false;
      }
    } else {
      if (!this.flatRate.title.trim()) {
        this.flatRateErrors.title = 'Title is required';
        isValid = false;
      }
    }

    if (!this.flatRate.flatRate) {
      this.flatRateErrors.flatRate = 'Flat rate is required';
      isValid = false;
    }

    this.flatRate.subItems.forEach((subItem: any, index) => {
      if (index !== this.flatRate.subItems.length - 1) {

        if (this.companyLocalization && this.currentLang === 'fr') {
          if (!subItem.titleFR && !subItem.title) {
            if (!this.errors[index]) {
              this.errors.splice(index, 1, {});
            }
            this.errors[index].title = 'French Title is required';
            isValid = false;
          }
        } else {
          if (!subItem.title && !subItem.titleFR) {
            if (!this.errors[index]) {
              this.errors.splice(index, 1, {});
            }
            this.errors[index].title = 'Title is required';
            isValid = false;
          }
        }

      }
    });

    return isValid;
  }

  onSubmit() {
    this.handleCalculateFlatRateTotal();

    if (!this.isValid()) {
      return;
    }

    const bundle = this.formatBundle();

    if (this.bundleId) {
      this.handleUpdateBundle(bundle);
    } else {
      this.handleCreateBundle(bundle);
    }
  }
}
